import { render, staticRenderFns } from "./StatisticsByLocation.htm?vue&type=template&id=4d363f98&scoped=true&"
import script from "./StatisticsByLocation.ts?vue&type=script&lang=js&"
export * from "./StatisticsByLocation.ts?vue&type=script&lang=js&"
import style0 from "./StatisticsByLocation.scss?vue&type=style&index=0&id=4d363f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d363f98",
  null
  
)

export default component.exports